export const aboutData = {
  title: "Who am I?",
  description1: "My name is Siddharth Bisht .",
  // description2:
  //   "Since I touched my 1st computer in 2011, I developed an interest in tech. I have come a long way from upgrading my own computer to installing operating systems. I am now interested in creating tech stuff like websites and applications, and I like to socialize, code, work out at the gym, and travel to new places. I prefer remote work and love to collaborate to open source.",
  description2: `Full Stack Web Developer with a good problem
  solving skills and the ability to perform well in a
  team. Passionate about building tech products,
  coding and enjoys socializing and teaching. `,
  image: 1
};
